import {
  GetMetafieldRequestQueryParamType,
  GetMetafieldResponseBodyType,
} from "@intelligems/ig-types";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api";
import { useGetOrg } from "../organizations/get-organization";
import { organizationsKeys } from "../queryKeys";

const getMetafield = async (params: GetMetafieldRequestQueryParamType) => {
  const resp = await api.get<GetMetafieldResponseBodyType>(
    `/v2/shops/metafield`,
    { params }
  );
  return resp.data;
};
export const useGetMetafield = (
  params: Partial<GetMetafieldRequestQueryParamType>
) => {
  const org = useGetOrg();

  const _params = {
    type: params.type!,
    id: params.id!,
    key: params.key!,
  };

  return useQuery<GetMetafieldResponseBodyType, Error>({
    queryKey: organizationsKeys.metafield(org.data.org.id, _params),
    queryFn: async () => getMetafield(_params),
    staleTime: 0,
    enabled: !!params.key && !!params.id && !!params.type,
  });
};
